import React, { Component } from 'react';

/**
 * Top-level render error boundary — prevents a white-screen crash with a recovery path.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bethere-bg flex min-h-screen flex-col items-center justify-center px-4 font-sans antialiased">
          <div className="max-w-md text-center">
            <h1 className="text-xl font-bold text-[#121212]">
              Something went wrong
            </h1>
            <p className="mt-2 text-sm text-[var(--muted-foreground)]">
              An unexpected error occurred. Try reloading the page.
            </p>
            <button
              type="button"
              className="mt-6 rounded bg-[var(--bethere-primary)] px-4 py-2 text-sm font-medium text-white"
              onClick={() => window.location.reload()}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
